<template>
  <div>
    <div id="login-container" class="login-container">
      <div class="logo-container pb-4">
        <img v-img="{ type:'logo', name: site_info[$i18n.locale.toLowerCase()].name }" class="other-logo" :src="(header_logo_url !== null && header_logo_url !== '' ? header_logo_url : require('@/assets/img/provider-default/default-logo-black.png'))" alt="Logo">
        <div class="img-logo-powered-portal" v-html="$t('M03e-09', { site_name: site_info[$i18n.locale.toLowerCase()].name })" />
      </div>
      <div class="container login-to-continue-container overflow-hidden">
        <div class="mx-lg-auto login-box text-center">
          <div>
            <h3 class="login-to-continue-title">{{ $t('M03e-02') }}</h3>
            <p>{{ $t('M03e-03', { site_name: providerDisplayName }) }}</p>
            <div class="login-img-wrapper">
              <img class="login-img" :src="require(`@/assets/svg/illustrations/lego-key.svg`)">
            </div>
            <a id="ga-M03e-05" :href="afterLoginLink">
              <span class="d-block mt-5 btn btn-primary">{{ $t('M03e-05') }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="back-to-homepage">
        <router-link :to="{ name: 'provider-info-branded', params: { provider_name: $route.params.provider_name, tab_name: 'home' } }">{{ $t('M03e-08', { site_name: providerDisplayName }) }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import providerInfoMixin from '@/mixins/provider-info'

export default {
  name: 'LoginToContinue',
  components: {
  },
  mixins: [providerInfoMixin],
  props: {
    redirectLink: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      header_logo_url: ''
    }
  },
  computed: {
    providerDisplayName() {
      return this.$store.getters.provider_display_name_raw
    },
    afterLoginLink() {
      if (this.redirectLink) {
        return this.$keycloak.createLoginUrl({ redirectUri: `${window.location.origin}${decodeURIComponent(this.redirectLink)}` })
      } else {
        return this.$keycloak.createLoginUrl()
      }
    },
    logo() {
      return this.$store.getters.logo_image
    },
    ...mapGetters([
      'site_info',
      'profile_image_url'
    ])
  },
  watch: {
    logo() {
      if (this.logo !== this.header_logo_url) {
        this.header_logo_url = this.logo
      }
    }
  },
  beforeDestroy() {
    window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
  },
  created() {
    console.log(this.providerInfo[0])
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
	height: 100vh;
  background-color: #F7FAFF;
  position: relative;
  overflow-y: scroll;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.logo-container {
	text-align: center;
}

.other-logo {
  max-height: 75px !important;
  width: 180px !important;
	margin-bottom: 16px;
}

.img-logo-powered-portal {
	color: #999999;
	margin: 0 !important;
	font-size: 14px;
}

.back-to-homepage {
	margin-top: 32px;
	font-size: 14px;
}

.login-to-continue-container {
  max-width: 548px;
  .login-box {
    border-radius: 5px;
    padding: 48px;
    background-color: #FFFFFF;
    box-shadow: 0 12px 15px 0 rgb(140 152 164 / 10%);
		.login-to-continue-title {
			margin-bottom: 16px;
		}
    .login-img {
			margin-top: 14px;
			width: 100px;
      max-width: 150px;
    }
    .login-divider {
      display: flex;
      align-items: center;
      text-align: center;
      margin: auto;
      max-width: 160px;
      padding: 32px 0px;
      span {
        padding: 0px 8px;
        font-size: 12px;
        line-height: 17px;
        color: #999;
      }
      &::before, &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid #E7EAF3;
      }
    }
    .register-link {
      cursor: pointer;
      color: #57abf0;
      &:hover {
        color: #007DBA;
      }
    }
		.btn {
			margin: 20px 0px 0px;
			font-weight: normal;
			font-size: 16px;
		}
  }

  @media screen and (max-width: 767px) {
    .login-box {
      padding: 20px 16px;

      .login-img-wrapper {
        max-height: 170px;
      }
      .login-img {
        margin-top: 0px !important;
        max-width: 50%;
        position: relative;
        top: calc(50% - 90px);
      }
    }
  }

  //  Handling for very small screens (<300px)
  @media screen and (max-width: 299px) {
    .login-box .login-img-wrapper {
      max-height: 180px;
    }
  }
}
</style>
